/**
 * Created by Dhanya Akhil on 2/02/2017.
 */
import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {AccountResourceService} from './account-resource.service';
import moment from 'moment';
import {ROLE_CONSTANTS} from '../constants/constant';
import {TokenService} from './token.service';

@Injectable()
export class PrincipalService {
  private _identity: any;
  private authenticated: boolean = false;
  private authenticationState = new Subject<any>();
  constructor(
    private accountResourceService: AccountResourceService,
    private tokenService: TokenService
  ) {}

  authenticate(_identity) {
    this._identity = _identity;
    this.authenticated = _identity !== null;
  }

  hasAnyAuthority(authorities) {
    if (!this.authenticated || !this._identity || !this._identity.authorities) {
      return false;
    }

    for (let i = 0; i < authorities.length; i++) {
      if (this._identity.authorities.indexOf(authorities[i]) !== -1) {
        return true;
      }
    }

    return false;
  }

  hasAuthority(authority): Promise<any> {
    if (!this.authenticated) {
      return Promise.resolve(false);
    }

    return this.identity().then(id => {
      return id.authorities && id.authorities.indexOf(authority) !== -1;
    }, () => {
      return false;
    });
  }

  identity(force?: boolean): Promise<any> {
    if (force === true) {
      this._identity = undefined;
    }

    // check and see if we have retrieved the _identity data from the server.
    // if we have, reuse it by immediately resolving
    if (this._identity) {
      return Promise.resolve(this._identity);
    }

    const token = this.tokenService.secureGet("token");
    // retrieve the _identity data from the server, update the _identity object, and then resolve.
    return this.accountResourceService.get(token).toPromise().then(account => {
      if (account) {
        this._identity = account;
        this.authenticated = true;
        //this.trackerService.connect();
      } else {
        this._identity = null;
        this.authenticated = false;
      }
      this.authenticationState.next(this._identity);
      return this._identity;
    }).catch(err => {
      this._identity = null;
      this.authenticated = false;
      this.authenticationState.next(this._identity);
      return null;
    });
  }

  isAuthenticated(): boolean {
    return this.authenticated;
  }

  isIdentityResolved(): boolean {
    return this._identity !== undefined;
  }

  getAuthenticationState(): Observable<any> {
    return this.authenticationState.asObservable();
  }

  getImageUrl(): String {
    return this.isIdentityResolved() ? this._identity.imageUrl : null;
  }

  getRole(roleID: string){
    if (roleID === ROLE_CONSTANTS.ROLE_ADMIN || roleID === ROLE_CONSTANTS.ROLE_EMPLOYER || roleID === ROLE_CONSTANTS.ROLE_SUPPORT) {
      return 'employer'
    } else if (roleID === ROLE_CONSTANTS.ROLE_EMPLOYEE) {
      return 'employee'
    }
  }

  getLastSuccessfulLogin(date: string){
    let formatDate = moment(date).format("DD MMM YYYY hh:mm a");
    return formatDate
  }

  getUserInfo(){
    let user = localStorage.getItem('account');
    return JSON.parse(user)
  }
}
